import { writable } from 'svelte/store';

let siteText            = 'SP Imobiliária';
let siteDescription     = 'Imobiliária em Canela - RS. Locação de Imóveis e Administração de Condomínios na Serra Gaúcha.';

export let tagsSEO      = writable('Desde 1988 atuando no mercado imobiliário da serra gaúcha.<br />Nossa sede própria está localizada no Centro de Canela, próxima à Igreja Matriz, com estacionamento e ampla estrutura de mais de 600,00m² para atendimento.');

export const alt				= writable(siteText);
export const headerTitleHome	= writable(siteText + " | " + siteDescription);
export const headerTitle		= writable("| " + siteText);
export const textSite			= writable(siteText);

// E-mails
export const mailAtendimento	= writable("siteatendimento@appspdigital.com.br");
export const mailLocacao		= writable("sitelocacoes@appspdigital.com.br");
export const mailVendas			= writable("sitevendas@appspdigital.com.br");
export const mailCondominios	= writable("sitecondominio@appspdigital.com.br");
export const mailOuvidoria		= writable("siteouvidoria@appspdigital.com.br");
export const mailRH				= writable("siterh@appspdigital.com.br");
export const mailLista			= writable("sitelista@appspdigital.com.br");
export const mailAtualize		= writable("sitealteracaocadastral@appspdigital.com.br");
export const mailLGPD			= writable("sitelgpd@appspdigital.com.br");

export const textTelefone		= writable("(54) 3282-4288");
export const linkTelefone		= writable("tel://5432824288");

export const whatsappGeral			= writable("555432821314");
export const textWhatsappGeral		= writable("(54) 3282-1314");
export const linkWhatsappGeral		= writable("https://wa.me/555432821314");

export const whatsappFinanceiro		= writable("555432821314");
export const textWhatsappFinanceiro	= writable("(54) 3282-1314");
export const linkWhatsappFinanceiro	= writable("https://wa.me/555432821314");

export const whatsappComercial		= writable("555432821314");
export const textWhatsappComercial	= writable("(54) 3282-1314");
export const linkWhatsappComercial	= writable("https://wa.me/555432821314");

export const whatsappAdm			= writable("555432821314");
export const textWhatsappAdm		= writable("(54) 3282-1314");
export const linkWhatsappAdm		= writable("https://wa.me/555432821314");

export const whatsappProposta		= writable("555432821314");
export const textWhatsappProposta	= writable("(54) 3282-1314");
export const linkWhatsappProposta	= writable("https://wa.me/555432821314");

export const whatsappLocacao		= writable("555432821314");
export const textWhatsappLocacao	= writable("(54) 3282-1314");
export const linkWhatsappLocacao	= writable("https://wa.me/555432821314");

export const whatsappVendas			= writable("5554996946260");
export const textWhatsappVendas		= writable("(54) 99694-6260");
export const linkWhatsappVendas		= writable("https://wa.me/5554996946260");

// Links
export const linkPesquisaVendas		= writable("/imoveis/vendas#nt=4&tipo_negociacao=4&cidade=Canela");
export const linkPesquisaLocacao	= writable("/imoveis/locacao#nt=2&tipo_negociacao=2&cidade=Canela");

// Redes Sociais e Atendimento
export const linkFacebook       = writable("https://www.facebook.com/spimobiliariacanela");
export const linkInstagram      = writable("https://www.instagram.com/spimobiliaria/");
export const linkYoutube        = writable("");
export const linkTwitter        = writable("");

export const linkMapa           = writable("https://g.page/spimobiliariacanela");
export const linkWaze           = writable("https://ul.waze.com/ul?place=ChIJR203ILctGZUR6Ap356-mzeM&ll=-29.36392050%2C-50.81080930&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location");
export const linkUber           = writable("https://m.uber.com/ul/?action=setPickup&client_id=WkI3hjPBTiXFkXX13R_eg0Y0bPAY3tlU&pickup=my_location&dropoff[formatted_address]=SP%20Imobili%C3%A1ria%20Loca%C3%A7%C3%A3o%20%26%20Administra%C3%A7%C3%A3o%20de%20Condom%C3%ADnio%20-%20Rua%20Felisberto%20Soares%20-%20Centro%2C%20Canela%20-%20RS%2C%20Brasil&dropoff[latitude]=-29.363920&dropoff[longitude]=-50.810809");
export const linkIframeMapa     = writable("https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3477.2176484229076!2d-50.81299798427341!3d-29.36391580691869!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95192db720376d47%3A0xe3cda6afe7770ae8!2zU1AgSW1vYmlsacOhcmlhIExvY2HDp8OjbyAmIEFkbWluaXN0cmHDp8OjbyBkZSBDb25kb23DrW5pbw!5e0!3m2!1spt-BR!2sbr!4v1631802432346!5m2!1spt-BR!2sbr");

export const linkAPI            = writable("https://www.api.com.br");
export const linkAV             = writable("https://spimobiliaria.com.br/spdigital/login");
export const linkAVConheca      = writable("https://spimobiliaria.com.br/conheca/");

export const linkRH 			= writable("https://spimobiliaria.vagas.solides.com.br/");

export const textAtendimento            = writable("De Segunda à Sexta-Feira, das 09h às 17:45,<br /> sem fechar ao meio-dia.");
export const textEndereco               = writable("Rua Felisberto Soares, 208, Canela - RS");
export const textCNPJ                   = writable("92.125.947/0001-47");
export const textCreci                  = writable("21.876-J");

export const linkPoliticaPrivacidade	= writable("/assets/files/PoliticaDePrivacidade.pdf");

export const textPoliticaCheck			= writable("<span style='font-size:12px;font-weight:normal;'>Autorizo a SP ADM e LOC de Bens LTDA e/o Condomínio armazenarem os dados acima em conformidade com a lei 13.709/2018 - LEI GERAL DE PROTEÇÃO DE DADOS PESSOAIS, e cuja utilização será exclusivamente para atender questões Condominiais e/ou Locatícias. Declaro verdadeiras as informações fornecidas e concordo com as <a style='text-decoration:underline;' href='/assets/files/PoliticaDePrivacidade.pdf' target='_blank'>Política de Privacidade</a>.</span>");
export const textPoliticaCheckTerceiro	= writable("<span style='font-size:12px;font-weight:normal;'>Autorizo a SP ADM e LOC de Bens LTDA e SOLUCIONE INTELIGÊNCIA IMOBILIÁRIA armazenarem os dados acima em conformidade com a lei 13.709/2018 - LEI GERAL DE PROTEÇÃO DE DADOS PESSOAIS, e cuja utilização será exclusivamente para atender questões de comercialização de imóveis. Declaro verdadeiras as informações fornecidas e concordo com as <a style='text-decoration:underline;' href='/assets/files/PoliticaDePrivacidade.pdf' target='_blank'>Política de Privacidade</a>.</span>");
